/**
 * LV PREMIUM FX
 * Scroll Clip Path Reveal + Progress Bar
 * Hafif, performanslı, Shopify uyumlu
 */
(function () {
  'use strict';

  /* ---- SCROLL PROGRESS BAR ---- */
  var bar = document.createElement('div');
  bar.id = 'lv-scroll-progress';
  document.body.appendChild(bar);

  /* ---- INTERSECTION OBSERVER — Clip Path Reveals ---- */
  var revealClasses = ['.lv-reveal', '.lv-reveal-left', '.lv-reveal-right', '.lv-reveal-center'];
  var revealEls = document.querySelectorAll(revealClasses.join(','));

  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lv-revealed');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });

  revealEls.forEach(function (el) { revealObs.observe(el); });

  /* ---- SCROLL PROGRESS UPDATE ---- */
  var ticking = false;
  function updateProgress() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docH > 0 ? Math.min(100, (scrollTop / docH) * 100) : 0;
    bar.style.width = pct.toFixed(1) + '%';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateProgress);
      ticking = true;
    }
  }, { passive: true });

  /* ---- REVEAL SINIFLARI OTOMATİK EKLE ---- */
  /* Lifestyle fotoğraflar */
  document.querySelectorAll('.lv-lifestyle-img, .lv-ab-img-box, .lv-sc-media').forEach(function (el, i) {
    el.classList.add(i % 2 === 0 ? 'lv-reveal-left' : 'lv-reveal-right');
    revealObs.observe(el);
  });

  /* Spec kartları */
  document.querySelectorAll('.lv-specs-mat-item').forEach(function (el, i) {
    el.classList.add('lv-reveal');
    el.classList.add('lv-reveal-d' + Math.min(i + 1, 4));
    revealObs.observe(el);
  });

  /* FAQ itemlar */
  /* FAQ items: reveal kaldirildi, her zaman gorunur */

  /* Hakkımızda bölümleri */
  document.querySelectorAll('.lv-ab-quote-box, .lv-ab-vision-card').forEach(function (el, i) {
    el.classList.add('lv-reveal-center');
    el.classList.add('lv-reveal-d' + Math.min(i + 1, 4));
    revealObs.observe(el);
  });

  /* Count up — sayısal değerler */
  var countEls = document.querySelectorAll('.lv-sp-count-val, .lv-spec-num-val, .lv-ab-num-val');
  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var raw = el.textContent.trim();
      var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(num) || num === 0) { countObs.unobserve(el); return; }
      var prefix = raw.match(/^[^0-9]*/)[0];
      var suffix = raw.match(/[^0-9.]*$/)[0];
      var start = 0, dur = 1200, startT;
      function step(ts) {
        if (!startT) startT = ts;
        var progress = Math.min((ts - startT) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = Math.round(start + (num - start) * eased);
        el.textContent = prefix + val + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      countObs.unobserve(el);
    });
  }, { threshold: 0.5 });

  countEls.forEach(function (el) { countObs.observe(el); });

})();
